import { createFileRoute } from '@tanstack/react-router'
import AuthSettings from '@/pages/settings/auth'

export const Route = createFileRoute(
  '/(protected)/settings/auth'
)({
  component: AuthSettings,
})